import { useState } from 'react';
import PageHeader from '../../components/common/PageHeader';
import { useAuth } from '../../contexts/AuthContext';
import { PERFIL_OPCOES } from '../../utils/acreditacaoOpcoes';

export default function Perfil() {
  const { user, atualizarUsuario, alterarSenha } = useAuth();
  const perfilLabel = PERFIL_OPCOES.find((p) => p.value === user?.perfil)?.label || user?.perfil;

  const [nome, setNome] = useState(user?.nome || '');
  const [salvandoNome, setSalvandoNome] = useState(false);
  const [nomeSalvo, setNomeSalvo] = useState(false);
  const [erroNome, setErroNome] = useState('');

  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [salvandoSenha, setSalvandoSenha] = useState(false);
  const [senhaSalva, setSenhaSalva] = useState(false);
  const [erroSenha, setErroSenha] = useState('');

  const salvarNome = async (e) => {
    e.preventDefault();
    setErroNome('');
    setNomeSalvo(false);
    setSalvandoNome(true);
    try {
      await atualizarUsuario({ nome });
      setNomeSalvo(true);
    } catch {
      setErroNome('Não foi possível salvar o nome.');
    } finally {
      setSalvandoNome(false);
    }
  };

  const salvarSenha = async (e) => {
    e.preventDefault();
    setErroSenha('');
    setSenhaSalva(false);

    if (novaSenha.length < 8) {
      setErroSenha('A nova senha deve ter ao menos 8 caracteres.');
      return;
    }
    if (novaSenha !== confirmarSenha) {
      setErroSenha('A confirmação não bate com a nova senha.');
      return;
    }

    setSalvandoSenha(true);
    try {
      await alterarSenha(senhaAtual, novaSenha);
      setSenhaSalva(true);
      setSenhaAtual('');
      setNovaSenha('');
      setConfirmarSenha('');
      setMostrarSenha(false);
    } catch (err) {
      setErroSenha(err?.response?.data?.detail || 'Não foi possível alterar a senha.');
    } finally {
      setSalvandoSenha(false);
    }
  };

  return (
    <div>
      <PageHeader titulo="Meu perfil" subtitulo={`${user?.email} · ${perfilLabel}`} />

      <div className="card-soft" style={{ padding: 28, maxWidth: 480, marginBottom: 20 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--am-tinta)', marginBottom: 16 }}>
          Dados pessoais
        </div>
        <form className="am-form" onSubmit={salvarNome}>
          <label className="am-field">
            <div className="am-field__label-row">
              <span className="am-field__label">Nome completo</span>
            </div>
            <input value={nome} onChange={(e) => setNome(e.target.value)} required />
          </label>

          {erroNome && <div className="am-field__error">{erroNome}</div>}

          <div className="d-flex align-items-center gap-2 justify-content-end">
            {nomeSalvo && <span style={{ fontSize: 13, color: 'var(--am-sucesso)' }}>Salvo!</span>}
            <button type="submit" className="am-btn am-btn-dark" disabled={salvandoNome}>
              {salvandoNome ? 'Salvando...' : 'Salvar nome'}
            </button>
          </div>
        </form>
      </div>

      <div className="card-soft" style={{ padding: 28, maxWidth: 480 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--am-tinta)', marginBottom: 4 }}>Senha</div>
        <p style={{ fontSize: 13, color: 'var(--am-cinza-texto-2)', marginBottom: 16 }}>
          Por segurança, você precisa confirmar sua senha atual para definir uma nova.
        </p>

        {!mostrarSenha ? (
          <button type="button" className="am-btn am-btn-outline" onClick={() => setMostrarSenha(true)}>
            <span className="ms">lock_reset</span>
            Redefinir senha
          </button>
        ) : (
          <form className="am-form" onSubmit={salvarSenha}>
            <label className="am-field">
              <div className="am-field__label-row">
                <span className="am-field__label">Senha atual</span>
              </div>
              <input type="password" value={senhaAtual} onChange={(e) => setSenhaAtual(e.target.value)} required />
            </label>
            <label className="am-field">
              <div className="am-field__label-row">
                <span className="am-field__label">Nova senha</span>
              </div>
              <input type="password" value={novaSenha} onChange={(e) => setNovaSenha(e.target.value)} minLength={8} required />
            </label>
            <label className="am-field">
              <div className="am-field__label-row">
                <span className="am-field__label">Confirmar nova senha</span>
              </div>
              <input type="password" value={confirmarSenha} onChange={(e) => setConfirmarSenha(e.target.value)} minLength={8} required />
            </label>

            {erroSenha && <div className="am-field__error">{erroSenha}</div>}

            <div className="am-form__actions">
              <button
                type="button"
                className="am-btn am-btn-outline"
                onClick={() => {
                  setMostrarSenha(false);
                  setErroSenha('');
                }}
              >
                Cancelar
              </button>
              <button type="submit" className="am-btn am-btn-dark" disabled={salvandoSenha}>
                {salvandoSenha ? 'Salvando...' : 'Salvar nova senha'}
              </button>
            </div>
          </form>
        )}

        {senhaSalva && (
          <div style={{ fontSize: 13, color: 'var(--am-sucesso)', marginTop: 12 }}>
            Senha alterada com sucesso!
          </div>
        )}
      </div>
    </div>
  );
}
